import { countryCodes, irelandCountryCode } from 'cpie-common';
import { Combobox, FormField } from '@vwfs-bronson/bronson-react';
import { useField } from 'formik';
import React, { useState } from 'react';
import { ComboboxState } from '../../../../../../types/bronson-react';

export const CountryCodeSelection: React.FC<{ name: string; testId: string; disabled?: boolean }> = ({
    name,
    testId,
    disabled,
}) => {
    const [field, , helpers] = useField(name);
    const [selectedCountryCode, setSelectedCountryCode] = useState({
        isOpen: false,
        value: [],
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setValueChange = (selectedCountryCode: any) => {
        helpers.setValue(selectedCountryCode[0].key);
        setSelectedCountryCode(prev => ({
            ...prev,
            value: selectedCountryCode,
        }));
    };

    const options = countryCodes.map(({ dialCode, name }: { dialCode: string; name: string }, index: number) => ({
        key: `${dialCode}${index}`,
        value: {
            textValue: `${dialCode}${index}`,
            content: (
                <span>
                    {name} <b>+{dialCode}</b>
                </span>
            ),
        },
    }));

    const defaultState: ComboboxState = {
        value: [
            {
                value: `+${field.value || irelandCountryCode}`,
                key: field.value || irelandCountryCode,
            },
        ],
    };

    return (
        <FormField type="select" id={'country-code-selection'}>
            <Combobox
                testId={`${testId}country-code-selection`}
                defaultState={defaultState}
                onChange={setValueChange}
                disabled={disabled}
                options={options}
                value={selectedCountryCode.value}
            />
        </FormField>
    );
};
